import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { LicensesService } from '../../services/licenses.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.scss']
})
export class LicensesComponent implements OnInit {
  gridLicenses: GridOptions;
  licensesSelected: any;
  activeAdd = false;
  enabledBtn = false;
  @ViewChild('isactive') isactive: ElementRef;

  constructor(private _serviceLicensesService: LicensesService, private toastrAlertHelper: ToastrAlertHelper) {
    this.initGrid();
  }

  ngOnInit() {}

  initGrid() {
    this.gridLicenses = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          headerName: 'Type',
          field: 'categorytypelicense.description',
          width: 100,
        },
        {
          headerName: 'Description',
          field: 'description',
          colId: 'description',
          width: 300,
        },
        {
          headerName: 'Status',
          field: 'isactive',
          cellRendererFramework: BooleanCheckComponent,
          colId: 'isactive',
          width: 70,
        },
      ],
      onGridReady: () => {
        this.gridLicenses.api.sizeColumnsToFit();
        this.onChangeShow(this.isactive.nativeElement.checked);
      },
    };
  }

  addNewLicense() {
    this.licensesSelected = null;
    this.changeActiveAdd();
  }

  onChangeShow(show: boolean) {
    this._serviceLicensesService.getTypeLicenseList(show).subscribe((data) => {
      const filter = this.gridLicenses.api.getFilterModel();
      this.gridLicenses.api.setRowData(data);
      this.gridLicenses.api.setFilterModel(filter);
    });
  }

  editLicenses($event) {
    this.licensesSelected = $event.data;
    this.changeActiveAdd();
  }

  changeActiveAdd() {
    this.activeAdd = !this.activeAdd;
    this.enabledBtn = !this.enabledBtn;
  }

  onNotify(resp: any): void {
    if (resp.success) {
      this.licensesSelected = null;
      this.toastrAlertHelper.success(resp.message);
      if (this.activeAdd) {
        this.changeActiveAdd();
      }
    } else {
      this.toastrAlertHelper.error(resp.message);
    }

    this.onChangeShow(this.isactive.nativeElement.checked);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/licenses/licenses.component.ts